/**
 * Web quầy mang MÀU của ngành sau đăng nhập (v0.23.0, ADR-115, docs/plans/mau-nganh-hai-app.md mục 3.3).
 *
 * Bảy biến CSS (`bienCssNganh` — một nguồn với khung xem trước ở Thông tin tiệm) đặt thẳng lên `<html>`; mọi phần tử, kể
 * cả tờ ở cuối <body>, đọc `var(--sp-…)`. Màu trạng thái lịch, đỏ lỗi, vàng cảnh báo, xanh lá thành công, ảnh đại diện và
 * nhãn "Đã đổi giờ" là token cố định (styles.css) nên KHÔNG đổi. Ngành lạ / chưa biết → xanh SAPA (ngành `khac`).
 *
 * `goc` là tham số để test bằng đối tượng giả; mặc định là `document`.
 */
import { apBienCss, bienCssNganh, boBienCss, laNganhTiem, NGANH } from '@sapa/shared'

export interface GocTaiLieu {
  documentElement: {
    style: { setProperty(k: string, v: string): void; removeProperty(k: string): void }
  }
  querySelector(chon: string): { content: string } | null
}

const META_THEME = 'meta[name="theme-color"]'

/** Đặt màu ngành lên <html> và thẻ theme-color (thanh trạng thái của điện thoại). */
export function apMauQuay(nganh: string | null | undefined, goc: GocTaiLieu = document): void {
  const n = laNganhTiem(nganh) ? nganh : null
  apBienCss(goc.documentElement, bienCssNganh(n))
  const meta = goc.querySelector(META_THEME)
  if (meta !== null) meta.content = NGANH[n ?? 'khac'].mau.primary
}

/** Gỡ màu ngành: về xanh SAPA của `:root` (màn đăng nhập, màn chờ, sau đăng xuất). */
export function boMauQuay(goc: GocTaiLieu = document): void {
  boBienCss(goc.documentElement, bienCssNganh(null))
  const meta = goc.querySelector(META_THEME)
  if (meta !== null) meta.content = NGANH.khac.mau.primary
}
